"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.ECC_READ_ALG = 'ECDH';
exports.ECC_WRITE_ALG = 'ECDSA';
exports.RSA_READ_ALG = 'RSA-OAEP';
exports.RSA_WRITE_ALG = 'RSASSA-PKCS1-v1_5';
exports.SALT_LENGTH = 128;
exports.DEFAULT_CRYPTOSYSTEM = 'ecc';
exports.DEFAULT_ECC_CURVE = types_1.EccCurve.P_256;
exports.DEFAULT_RSA_SIZE = types_1.RsaSize.B2048;
exports.DEFAULT_SYMM_ALG = types_1.SymmAlg.AES_CTR;
exports.DEFAULT_SYMM_LEN = types_1.SymmKeyLength.B256;
exports.DEFAULT_CTR_LEN = 64;
exports.DEFAULT_HASH_ALG = types_1.HashAlg.SHA_256;
exports.DEFAULT_CHAR_SIZE = types_1.CharSize.B16;
exports.DEFAULT_STORE_NAME = 'keystore';
exports.DEFAULT_READ_KEY_NAME = 'read-key';
exports.DEFAULT_WRITE_KEY_NAME = 'write-key';
exports.default = {
    ECC_READ_ALG: exports.ECC_READ_ALG,
    ECC_WRITE_ALG: exports.ECC_WRITE_ALG,
    RSA_READ_ALG: exports.RSA_READ_ALG,
    RSA_WRITE_ALG: exports.RSA_WRITE_ALG,
    SALT_LENGTH: exports.SALT_LENGTH,
    DEFAULT_CRYPTOSYSTEM: exports.DEFAULT_CRYPTOSYSTEM,
    DEFAULT_ECC_CURVE: exports.DEFAULT_ECC_CURVE,
    DEFAULT_RSA_SIZE: exports.DEFAULT_RSA_SIZE,
    DEFAULT_SYMM_ALG: exports.DEFAULT_SYMM_ALG,
    DEFAULT_CTR_LEN: exports.DEFAULT_CTR_LEN,
    DEFAULT_HASH_ALG: exports.DEFAULT_HASH_ALG,
    DEFAULT_CHAR_SIZE: exports.DEFAULT_CHAR_SIZE,
    DEFAULT_STORE_NAME: exports.DEFAULT_STORE_NAME,
    DEFAULT_READ_KEY_NAME: exports.DEFAULT_READ_KEY_NAME,
    DEFAULT_WRITE_KEY_NAME: exports.DEFAULT_WRITE_KEY_NAME,
};
//# sourceMappingURL=constants.js.map